import React from "react";
import moment from "moment";
import NotificationItem from "./NotificationItem";
import { NOTIFICATION_GROUP_TYPES } from "./utils";

const DateGroupedSection = ({ title, notifications, onMarkAsRead }) => {
  if (!notifications || notifications.length === 0) {
    return null;
  }

  return (
    <div style={{ marginBottom: 8 }}>
      <div
        style={{
          backgroundColor: "rgba(237, 1, 127, 0.2)",
          borderRadius: "3px",
          height: "20px",
          color: "#383838",
          padding: "2px 6px",
          fontSize: 11,
          fontWeight: 500,
          fontFamily: "'poppins', Arial",
          textTransform: "uppercase",
        }}
      >
        {title}
      </div>
      <div>
        {notifications.map((notification) => (
          <NotificationItem
            key={notification.id}
            notification={notification}
            onMarkAsRead={onMarkAsRead}
          />
        ))}
      </div>
    </div>
  );
};

const NotificationList = ({ groupedNotifications = {}, onMarkAsRead }) => {
  const hasNotifications = groupedNotifications && Object.keys(groupedNotifications).length > 0;
  const hasToday = groupedNotifications[NOTIFICATION_GROUP_TYPES.TODAY]?.length > 0;
  const hasYesterday = groupedNotifications[NOTIFICATION_GROUP_TYPES.YESTERDAY]?.length > 0;
  const hasOlder = groupedNotifications.older && Object.keys(groupedNotifications.older).length > 0;

  if (!hasNotifications || (!hasToday && !hasYesterday && !hasOlder)) {
    return (
      <div
        style={{
          padding: 20,
          textAlign: "center",
          color: "#999999",
          fontFamily: "'poppins', Arial",
          fontSize: 11,
        }}
      >
        No notifications
      </div>
    );
  }

  const olderDates = hasOlder ? Object.keys(groupedNotifications.older).sort((a, b) => {
    return moment(b, "DD MMMM YYYY").valueOf() - moment(a, "DD MMMM YYYY").valueOf();
  }) : [];

  return (
    <div style={{ flex: 1, overflowY: "auto" }}>
      <DateGroupedSection
        title={NOTIFICATION_GROUP_TYPES.TODAY}
        notifications={groupedNotifications[NOTIFICATION_GROUP_TYPES.TODAY]}
        onMarkAsRead={onMarkAsRead}
      />
      <DateGroupedSection
        title={NOTIFICATION_GROUP_TYPES.YESTERDAY}
        notifications={groupedNotifications[NOTIFICATION_GROUP_TYPES.YESTERDAY]}
        onMarkAsRead={onMarkAsRead}
      />
      {olderDates.map((dateKey) => (
        <DateGroupedSection
          key={dateKey}
          title={dateKey}
          notifications={groupedNotifications.older[dateKey]}
          onMarkAsRead={onMarkAsRead}
        />
      ))}
    </div>
  );
};

export default NotificationList;